(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-global-enhancements"]) return;
  try {
    
let pcCartRequest;
let pcCartTimer;
async function pcRefreshCartUI() {
  pcCartRequest?.abort();
  const controller = new AbortController();
  pcCartRequest = controller;
  const root = window.Shopify?.routes?.root || '/';
  try {
    const response = await fetch(root + 'cart.js', {signal:controller.signal,headers:{Accept:'application/json'}});
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-pc-cart-count]').forEach((badge) => {
      badge.textContent = String(cart.item_count);
      badge.hidden = cart.item_count === 0;
    });
    const section = document.querySelector('[data-pc-cart-section]');
    if (!section) return;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', section.dataset.pcCartSection);
    const sectionResponse = await fetch(url, {signal:controller.signal});
    if (!sectionResponse.ok) return;
    const html = new DOMParser().parseFromString(await sectionResponse.text(), 'text/html');
    const replacement = html.querySelector('[data-pc-cart-section]');
    if (replacement) section.replaceWith(replacement);
  } catch (error) {
    if (error.name !== 'AbortError') {
      const section = document.querySelector('[data-pc-cart-section]');
      if (section) section.hidden = true;
    }
  }
}
function pcScheduleCartRefresh() { clearTimeout(pcCartTimer); pcCartTimer = setTimeout(pcRefreshCartUI, 180); }
document.addEventListener('cart:update', pcScheduleCartRefresh);
document.addEventListener('discount:update', pcScheduleCartRefresh);
window.addEventListener('pageshow', pcScheduleCartRefresh);
document.addEventListener('visibilitychange', () => { if (!document.hidden) pcScheduleCartRefresh(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-header"]) return;
  try {
    
document.addEventListener('keydown',(event)=>{if(event.key!=='Escape')return;const openMenus=document.querySelectorAll('.pc-site-header details[open]');const menu=[...openMenus].reverse().find((item)=>item.contains(document.activeElement));if(menu){menu.open=false;menu.querySelector('summary')?.focus();}});
document.addEventListener('click',(event)=>{document.querySelectorAll('.pc-site-header details[open]').forEach((menu)=>{if(!menu.contains(event.target))menu.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-rituals"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pc-ritual-add]').forEach((button) => {
    if (button.dataset.pcBound === '1') return;
    button.dataset.pcBound = '1';
    button.addEventListener('click', async () => {
      const status = button.closest('.pc-rituals')?.querySelector('.pc-rituals__status');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = button.closest('.pc-rituals').dataset.adding;
      if (status) status.textContent = '';
      try {
        const items = JSON.parse(button.dataset.items || '[]');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if (!response.ok) throw new Error('No se pudo añadir la combinación');
        window.location.href = button.closest('.pc-rituals').dataset.cartUrl;
      } catch (error) {
        button.disabled = false;
        button.textContent = original;
        if (status) status.textContent = button.closest('.pc-rituals').dataset.error;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
